export default __webpack_public_path__ + "static/media/nusa.848abb7c.mp4";